import genders from 'data/genders/messages'
import languages from 'data/languages/messages'
import categories from 'data/categories/messages'

const messageMap = {
  genders,
  languages,
  categories,
}

export const reverseLookupMessage = (messages, key, formatMessage) => {
  return getMessageFromKey(messageMap[messages], key, formatMessage)
}

export const getMessageFromKey = (messages, value, formatMessage) => {
  const possibleKeys = Object.keys(messages).filter((keyName) =>
    keyName.endsWith('URL')
  )
  const valueMap = possibleKeys.reduce((memo, key) => {
    memo[formatMessage(messages[key])] = key.replace(/URL/, '')
    return memo
  }, {})

  return valueMap[value] ? valueMap[value] : value
}

export const getKeyFromMessage = (messages, key, formatMessage) => {
  return messages[key + 'URL'] ? formatMessage(messages[key + 'URL']) : key
}
